module.exports = __webpack_public_path__ + "static/media/fix_mercedes.b966e9cd.png";